module.exports = __webpack_public_path__ + "img/Aimo.11ac95ff.jpg";